import React from "react";

import {OfferLocationLinksItem} from "../../offer/atoms/OfferListLocationLinksItem";
import {OfferLocationLinksList} from "../../offer/atoms/OfferLocationLinksList";

interface Link {
    href: string;
    text: string;
}

interface IProps {
    className?: string;
    links: Link[];
}

export const PromotionInternalLinks = (props: IProps) => {
    return (
        <div className={props.className}>
            <OfferLocationLinksList title="Sprawdź także">
                {props.links?.map((link) => (
                    <OfferLocationLinksItem key={`${link.href}${link.text}`} linkText={link.text} url={link.href} />
                ))}
            </OfferLocationLinksList>
        </div>
    );
};
import React from "react";

import {OfferLocationLinksItem} from "../../offer/atoms/OfferListLocationLinksItem";
import {OfferLocationLinksList} from "../../offer/atoms/OfferLocationLinksList";

interface Link {
    href: string;
    text: string;
}

interface IProps {
    className?: string;
    links: Link[];
}

export const PromotionInternalLinks = (props: IProps) => {
    return (
        <div className={props.className}>
            <OfferLocationLinksList title="Sprawdź także">
                {props.links?.map((link) => (
                    <OfferLocationLinksItem key={`${link.href}${link.text}`} linkText={link.text} url={link.href} />
                ))}
            </OfferLocationLinksList>
        </div>
    );
};
